import React, { useEffect, useState, useRef } from "react";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import GangnamSeatSvg from "../etc/gangnamseatsvg";
import { Button, LinearProgress, Slider } from "@mui/joy";
import PrintIcon from '@mui/icons-material/Print';
import ReactToPrint from 'react-to-print';
import { each, set } from "lodash";
import DaechiSeatSvg from "../etc/daechiseatsvg";
import Daechi2SeatSvg from "../etc/daechi2seatsvg";
import Daechi3SeatSvg from "../etc/daechi3seatsvg";
import totalLocationData from "../../../data/locationdata";
import { renderSeatSvg, getGenderSeatColor } from "../../../data/locationFuntion";
import JobAttendance from "./jobattendance";

var maxSeatNumber = {
    gangnam : 75,
    gangnam2 : 67,
    daechi : 73,
    daechi2 : 84,
    daechi3 : 73,
    songpa : 96,
    daegu : 156,
    gimpo : 177,
    sinchon : 147,
    bundang : 146,
    hanam : 126,
    gangdong : 154,
    centum : 122,
    dongtan : 108
}

const SeatList: React.FC<any> = (props) => {


    const [location, setLocation] = useState("");
    const [sliderValue, setSliderValue] = useState(5);
    const ref = useRef(null);
    const [loading, setLoading] = useState(false);

    const [count, setCount] = useState(0);
    const [unassignedCount, setUnassignedCount] = useState(0);   // 좌석 미배정 재원생 수 (신규 미배정 등)
    const [unassignedList, setUnassignedList] = useState<any[]>([]);   // 미배정 학생 이름 목록
    const [showUnassignedList, setShowUnassignedList] = useState(false); // 이름 펼침 토글

    //index가 200개 있는 state를 만든다.
    const [memo, setMemo] = useState(new Array(200).fill(""));

    //지점별 자유 메모 (리치 텍스트 — 색/굵기 지원)
    const [memoLoaded, setMemoLoaded] = useState(false);
    const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);
    const editorRef = useRef<HTMLDivElement>(null);

    //프리셋 색 목록
    const memoColors = [
        { name: "검정", value: "#000000" },
        { name: "빨강", value: "#d32f2f" },
        { name: "파랑", value: "#1976d2" },
        { name: "초록", value: "#388e3c" },
        { name: "노랑", value: "#f9a825" },
    ];

    useEffect(() => {

        //location이 바뀔 때마다 실행된다.
        console.log("Location changed:", location);

        //slidervalue에 따라서 ref의 width를 바꾼다.
        if (!ref.current) {
            return;
        }

        const element = ref.current as any;

        //element width를 바꾼다.
        if (location) {
            element.style.width = `${(sliderValue + 5) * 200}px`;
        }

    }, [location, ref.current]);

    useEffect(() => {

        if (!props.user || !props.user.academy) {
            return;
        }

        const academy = props.user.academy;

        const filteredLocationData = totalLocationData.filter((locationData) => {

            if (locationData.english === "total") {
                return false;
            }

            return locationData.academy.includes(academy);
        })

        const firstLocationData = filteredLocationData[0];

        if (academy !== "sunbae") {
            setLocation(firstLocationData.english);
        } else {
            setLocation("job");
        }

    }, [props.user]);

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setLocation(newValue);
    };

    const createChangeHandler = (seat: number) => (e: any) => {

        handleInputChange(e, seat);

    }

    const handleInputChange = async (e: any, seat: number) => {


        const value = e.target.value;

        

        const data = {
            seat,
            location,
            value
        }

        const response = await fetch("https://peetsunbae.com/dashboard/avatar/seatlistmemo", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        })

        const result = await response.json();

        

        if (result.message === "success") {
            
        }

    }

    useEffect(() => {

        if (!location) {
            return;
        }


        getInfo(location);
    }, [location]);

    //지점 변경 시 메모 새로 불러오기
    useEffect(() => {

        if (!location || location === "job") {
            if (editorRef.current) {
                editorRef.current.innerHTML = "";
            }
            setMemoLoaded(false);
            return;
        }

        setMemoLoaded(false);

        fetch(`https://peetsunbae.com/dashboard/avatar/locationmemo?location=${location}`, {
            method: "GET",
            credentials: "include"
        })
            .then(r => r.json())
            .then(result => {
                if (result.message === "success") {
                    const html = (result.data && result.data.description) ? result.data.description : "";
                    if (editorRef.current) {
                        editorRef.current.innerHTML = html;
                    }
                    setMemoLoaded(true);
                }
            })
            .catch((e) => {
                console.log(e);
            });

    }, [location]);

    //unmount 시 debounce 타이머 정리
    useEffect(() => {
        return () => {
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
        };
    }, []);

    //공통 저장 로직 — 현재 editor innerHTML을 1초 debounce 후 서버에 저장
    const scheduleSave = () => {

        if (!memoLoaded) return;
        if (!editorRef.current) return;

        const html = editorRef.current.innerHTML;

        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
        }

        debounceTimerRef.current = setTimeout(() => {
            fetch("https://peetsunbae.com/dashboard/avatar/locationmemo", {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ location, description: html })
            }).catch((e) => {
                console.log(e);
            });
            debounceTimerRef.current = null;
        }, 1000);

    }

    const handleEditorInput = (e: React.FormEvent<HTMLDivElement>) => {
        scheduleSave();
    }

    //toolbar 버튼의 onMouseDown — 기본 동작(=button focus) 막아서 editor selection 유지
    const preventFocusSteal = (e: React.MouseEvent) => {
        e.preventDefault();
    }

    const applyBold = () => {
        // <b> 태그로 통일 (styleWithCSS=false) → CSS에서 font-weight:900 강제 적용
        document.execCommand("styleWithCSS", false, "false");
        document.execCommand("bold");
        scheduleSave();
    }

    const applyColor = (color: string) => () => {
        document.execCommand("styleWithCSS", false, "true");
        document.execCommand("foreColor", false, color);
        scheduleSave();
    }

    const getJobInfo = async () => {

        try {

        } catch (e) {
            
        }

    }


    const getInfo = async (location: string) => {

        if (!location) {
            return;
        }

        if (location === "job") {
            getJobInfo();
            return;
        }

        try {

            setLoading(true);

            const response = await fetch(`https://peetsunbae.com/dashboard/avatar/seatlist?location=${location}`, {
                method: "GET",
                credentials: "include"
            })

            const result = await response.json();

            

            if (result.message === "success") {
                setLoading(false);
                const data = result.data;
                const futureData = result.futureData || [];
                drawSeat(data, location, futureData);

            }

        } catch (e) {
            
        }

    }

    const drawSeat = (data: any[], location: string, futureData : any[] = []) => {

        var count = 0;
        var unassignedCount = 0;   // 이 지점 소속이지만 좌석번호가 없는 재원생(신규 미배정 등)
        const unassignedStudents: any[] = [];   // 미배정 학생 이름 목록 (클릭 시 표시용)

        //좌석 칸 순회 루프는 seat이 있는 학생만 방문하므로, 미배정 인원은 루프 밖에서 별도 집계한다.
        //data(=오늘 기준 재원) + futureData(=입학예정) 중 학생인데 이름은 있고 seat이 없는 사람.
        //value === "student" 필수: studentLocation에는 학부모/선생 행도 섞여 있어 빼야 함.
        //(빈 좌석 placeholder는 name이 ""이라 자연히 제외됨)
        [...data, ...futureData].forEach((eachData: any) => {
            if (eachData.value === "student" && eachData.name && !eachData.seat) {
                unassignedCount += 1;
                unassignedStudents.push({ name: eachData.name, firstCome: eachData.firstCome });
            }
        });

        //등원날짜(firstCome) 빠른 순으로 정렬. firstCome 없는 학생은 맨 뒤로.
        unassignedStudents.sort((a, b) => {
            const at = a.firstCome ? new Date(a.firstCome).getTime() : Infinity;
            const bt = b.firstCome ? new Date(b.firstCome).getTime() : Infinity;
            return at - bt;
        });

        const handleClick = (id: number) => () => {
            //alert(`Clicked ID: ${id}`);
        };

        const locationInfo = totalLocationData.find((eachLocation) => eachLocation.english === location);
        const isFree = locationInfo?.isFree;


        data.forEach((eachData: any) => {

            eachData.isNowInClass = false;

            if (eachData.accessControlData.length === 0) {
                return;
            }

            if (eachData.accessControlData[0].direction === "outside") {
                eachData.isNowInClass = true;
            }

        })

        var maxI = 76;

        if (location === "daechi2") {
            maxI = 200;
        }

        if (location === "daechi3") {
            maxI = 300;
        }

        maxI = 301;

        if(location === "getL"){
            maxI = 401;
        }

        if(location === "getA" || location === "get50"){
            maxI = 601;
        }

        console.log("maxI", maxI);

        for (var i = 1; i < maxI; i++) {
            for (var j = 0; j < 3; j++) {

                var targetId = i * 10 + j;


                const element = document.getElementById(targetId.toString());
                //
                

                if (!element) {
                    continue
                }

                element.addEventListener("click", handleClick(targetId));

                //element 밑에 있는 태그 path를 가져온다.
                const path = element.getElementsByTagName("path")[0];

                //좌석칸(j===0)이면 남녀석 범위에 따라 배경색을 칠한다. (대상 지점이 아니면 null → 기본 회색 유지)
                if (j === 0 && path) {
                    const genderColor = getGenderSeatColor(location, i);
                    if (genderColor) {
                        path.setAttribute("fill", genderColor);
                    }
                }

                //path의 fill을 red로 바꾼다.


                //element밑에 있는 text를 가져온다.
                const text = element.getElementsByTagName("text")[0];
                //text의 text-anchor를 middle로 바꾼다.
                text.setAttribute("text-anchor", "middle");


                //element밑에 있는 tspan을 가져온다.
                const tspan = element.getElementsByTagName("tspan")[0];

                var name = "";


                //tspan의 글씨 크기를 바꾼다.
                tspan.setAttribute("font-size", "16px");

                if (targetId % 10 === 1) {

                    data.forEach((eachData: any) => {
                        if (!eachData.seat) {
                            return;
                        }

                        //i값이랑 eachData.seat이랑 같으면 eachData.name을 name에 추가한다.
                        if (i === +eachData.seat) {
                            name += eachData.name;

                            if(eachData.name){
                                count += 1;
                            }

                        }
                    })
                    //tspan의 text에 name을 넣는다.
                    tspan.textContent = name;

                    futureData.forEach((eachData: any) => {
                        if (!eachData.seat) {
                            return;
                        }

                        if (i === +eachData.seat) {
                            //tspan의 text에 eachData.name을 추가한다.
                            const innerTspan = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
                            tspan.appendChild(innerTspan);

                            if(!name){
                                count += 1;
                            }

                            innerTspan.textContent = name ? ` / ${eachData.name}` : eachData.name;
                            //innerTspan의 font-size를 16px로 바꾼다.
                            innerTspan.setAttribute("font-size", "16px");

                            innerTspan.setAttribute("fill", "gray");
                        }
                    });


                                    //tspan 속에 tspan을 추가한다.
                    
                }

                //data.isNowInClass가 true면 tspan의 background color를 blue로 false면 red로 바꾼다.
                data.forEach((eachData: any) => {
                    if (!eachData.seat) {
                        return;
                    }

                    if (i === +eachData.seat) {
                        if (eachData.isNowInClass) {
                            //tspan.setAttribute("fill", "#0B6BCB");
                            tspan.setAttribute("fill", "blue");
                        } else {
                            tspan.setAttribute("fill", "#C41C1C");
                        }
                    }
                })

                



                //tsapn의 attribute중 x를 값을 바꾼다.
                //27.5가 정중앙
                tspan.setAttribute("x", "45.5");
                //tspan.setAttribute("y", "18.7");
                tspan.setAttribute("y", "19.2");

                if(location === "molip"){
                    if(i >= 86 && i <= 92){
                        tspan.setAttribute("x", "60");
                    }

                    if(i >= 99 && i <= 102){
                        tspan.setAttribute("x", "70");
                    }

                    if(i >= 93 && i <= 98){
                        tspan.setAttribute("x", "52");
                    }

                    if(i>=103 && i <=105){
                        tspan.setAttribute("x", "52");
                    }  

                    if(i === 300){
                        tspan.setAttribute("x", "102");
                    }
                }

                if(location === "getL"){


                tspan.setAttribute("font-size", "22px");
                    tspan.setAttribute("x", "64");
                    tspan.setAttribute("y", "25");

                    if(i >= 301 && i <=314){
                        tspan.setAttribute("x", "75");
                        tspan.setAttribute("y", "24");
                    }


                }


                if (targetId % 10 === 2) {

                    tspan.textContent = "";
                    const path = element.getElementsByTagName("path")[0];

                    //path의 transform 속성을 가져온다.
                    const transform = path.getAttribute("transform");

                    //transform의 형식은 translate(x, y)이다.
                    //x값을 가져온다.
                    var x : any = transform?.split(" ")[0].split("(")[1];
                    //y값을 가져온다.
                    var y : any = transform?.split(" ")[1].split(")")[0];

                    if(!x){
                        const bbox = path.getBBox();
                        x = bbox.x;
                    }

                    if(!y){
                        const bbox = path.getBBox();
                        y = bbox.y;
                    }


                    const foreignObject = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
                    foreignObject.setAttribute('x', x?.toString() || "");
                    foreignObject.setAttribute('y', y?.toString() || "");
                    foreignObject.setAttribute('width', '91.1');
                    foreignObject.setAttribute('height', '25.7');

                    


                    // input 태그 생성
                    const input = document.createElement('input');
                    input.type = 'text';
                    input.style.width = '100%';
                    input.style.height = '100%';
                    input.style.border = 'none';
                    input.style.backgroundColor = 'transparent';
                    input.style.fontFamily = '맑은 고딕';
                    input.style.fontSize = '16px';
                    //input.style.color = '#C41C1C';
                    input.style.textAlign = 'center';

                    // input.addEventListener("change", (e) => {
                    //     handleInputChange(e, i);
                    // });

                    data.forEach((eachData: any) => {
                        if (!eachData.seat) {
                            return;
                        }

                        if (i === +eachData.seat) {
                            input.value = eachData.seatMemo;
                        }

                    })




                    input.addEventListener("change", createChangeHandler(i));
                    foreignObject.appendChild(input);
                    element.appendChild(foreignObject);



                }

            }
        }

        setCount(count);
        setUnassignedCount(unassignedCount);
        setUnassignedList(unassignedStudents);
        setShowUnassignedList(false);   // 지점/데이터 새로 그릴 때 목록은 접어둠

    }


    return (
        <div>
            <div style={{ width: "1200px", margin: "0 auto" }}>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={location}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="lab API tabs example" sx={{ "& .MuiTabs-flexContainer": { flexWrap: "wrap", justifyContent: "flex-start", gap: 1 }, "& .MuiTab-root": { minWidth: "auto" } }}>
                                {/* <Tab label={<span style={{ fontFamily: "Apple_SB" }}>강남점</span>} value="gangnam" />
                                <Tab label={<span style={{ fontFamily: "Apple_SB" }}>대치점</span>} value="daechi" />
                                <Tab label={<span style={{ fontFamily: "Apple_SB" }}>대치3층</span>} value="daechi2" />
                                <Tab label={<span style={{ fontFamily: "Apple_SB" }}>대치6층</span>} value="daechi3" /> */}
                                <Tab label={<span style={{ fontFamily: "Apple_SB" }}>직원</span>} value="job" />
                                {
                                    (props.user && props.user.academy) && totalLocationData.map((locationData, index) => {

                                        if (locationData.english === "total") {
                                            return;
                                        }

                                        if (!locationData.academy.includes(props.user.academy)) {
                                            return;
                                        }

                                        return (
                                            <Tab label={<span style={{ fontFamily: "Apple_SB" }}>{locationData.korean}</span>} value={locationData.english} key={index} />
                                        )

                                    })
                                }
                            </TabList>
                        </Box>
                    </TabContext>
                </Box>
            </div>

            {
                location !== "job" &&
                <>
                    <div style={{ width: "1200px", display: "flex", justifyContent: "flex-end", margin: "0 auto", marginTop: "12px" }}>
                        <div>
                            <ReactToPrint
                                onAfterPrint={() => {
                                    
                                }}
                                trigger={() => {
                                    return (
                                        <Button size="lg" variant='soft' color='neutral'>
                                            <PrintIcon />
                                        </Button>
                                    )
                                }
                                }
                                content={() => ref.current}
                            />
                        </div>
                    </div>



                    <div style={{ width: "1200px", display: "flex", justifyContent: "flex-end", margin: "0 auto" }}>
                        <div style={{ width: "200px", marginTop: "24px" }}>
                            <Slider
                                variant="solid"
                                size="lg"
                                color="success"
                                min={1}
                                max={9}
                                value={sliderValue}
                                onChange={(e, value) => {

                                    if (!ref.current) {
                                        return;
                                    }

                                    const element = ref.current as any;

                                    //value가 number가 아니면 return
                                    if (typeof value !== "number") {
                                        return;
                                    }

                                    console.log(value);
                                    console.log(element.style.width);

                                    // //element width를 바꾼다.
                                    if (value) {
                                        element.style.width = `${(value + 5) * 200}px`;
                                    }

                                    
                                    setSliderValue(value as number);
                                }}
                            />
                        </div>
                    </div>

                    {/* 충원율 — 배정 인원 / 미배정 포함 2가지 (고정폭 박스 + 좌측정렬로 줄 맞춤) */}
                    <div style={{
                        width : "1200px",
                        margin : "0 auto",
                        marginTop : "12px",
                        marginBottom : "12px",
                        fontFamily : "Apple_SB",
                        display : "flex",
                        justifyContent : "flex-end"
                    }}>
                        <div style={{ width: "460px" }}>
                            {/* 배정 인원 — 좌석번호가 배정된 인원 (기존 값) */}
                            <div style={{
                                display : "flex",
                                justifyContent : "flex-start",
                                alignItems : "baseline",
                                fontSize : "18px",
                                marginBottom : "4px"
                            }}>
                                <span style={{ width: "84px", color: "#666", fontSize: "15px" }}>배정 인원</span>
                                <span style={{ width: "96px" }}>{count} / {maxSeatNumber[location as keyof typeof maxSeatNumber]}</span>
                                {(() => {
                                    const max = maxSeatNumber[location as keyof typeof maxSeatNumber];
                                    if (!max) return null;
                                    const pct = (count / max) * 100;
                                    return <span style={{ color: "#666", fontSize: "15px" }}>· 충원율 {pct.toFixed(1)}%</span>;
                                })()}
                            </div>

                            {/* 미배정 포함 — 배정 인원 + 좌석번호 없는 재원생(신규 미배정 등) */}
                            <div style={{
                                display : "flex",
                                justifyContent : "flex-start",
                                alignItems : "baseline",
                                fontSize : "18px"
                            }}>
                                <span style={{ width: "84px", color: "#666", fontSize: "15px" }}>미배정 포함</span>
                                <span style={{ width: "96px" }}>{count + unassignedCount} / {maxSeatNumber[location as keyof typeof maxSeatNumber]}</span>
                                {(() => {
                                    const max = maxSeatNumber[location as keyof typeof maxSeatNumber];
                                    if (!max) return null;
                                    const pct = ((count + unassignedCount) / max) * 100;
                                    return <span style={{ color: "#666", fontSize: "15px" }}>· 충원율 {pct.toFixed(1)}%</span>;
                                })()}
                                {
                                    unassignedCount > 0 ?
                                    <span
                                        onClick={() => setShowUnassignedList(v => !v)}
                                        style={{
                                            color: "#1976d2", fontSize: "13px", marginLeft: "10px",
                                            cursor: "pointer", textDecoration: "underline", userSelect: "none"
                                        }}
                                    >
                                        (미배정 {unassignedCount}명 {showUnassignedList ? "▲" : "▼"})
                                    </span>
                                    :
                                    <span style={{ color: "#999", fontSize: "13px", marginLeft: "10px" }}>(미배정 0명)</span>
                                }
                            </div>

                            {/* 펼친 미배정 학생 이름 목록 */}
                            {
                                showUnassignedList &&
                                <div style={{
                                    marginTop: "6px", padding: "8px 12px", border: "1px solid #e0e0e0",
                                    borderRadius: "6px", background: "#fafafa", fontSize: "13px", color: "#444",
                                    maxHeight: "160px", overflowY: "auto", lineHeight: 1.7
                                }}>
                                    {unassignedList.map((s, i) => (
                                        <span key={i} style={{ marginRight: "12px", display: "inline-block", whiteSpace: "nowrap" }}>
                                            {s.name}{s.firstCome ? ` (입학예정 ${new Date(s.firstCome).getMonth() + 1}/${new Date(s.firstCome).getDate()})` : ""}
                                        </span>
                                    ))}
                                </div>
                            }
                        </div>
                    </div>

                    {/* 지점 메모 리치 텍스트 — 500px 우측 정렬, 색/굵기 toolbar 포함 */}
                    <div style={{ width: "1200px", display: "flex", justifyContent: "flex-end", margin: "0 auto", marginBottom: "16px" }}>
                        <div style={{ width: "500px" }}>
                            {/* Apple_SB가 이미 SemiBold라 일반 bold(700)는 티가 안 남 — 900으로 강제 */}
                            <style>{`
                                .seatmemo-editor b,
                                .seatmemo-editor strong {
                                    font-weight: 900;
                                }
                            `}</style>

                            {/* toolbar */}
                            <div style={{
                                display: "flex",
                                gap: "6px",
                                alignItems: "center",
                                marginBottom: "6px"
                            }}>
                                <button
                                    type="button"
                                    onMouseDown={preventFocusSteal}
                                    onClick={applyBold}
                                    style={{
                                        fontWeight: 900,
                                        fontFamily: "Apple_SB",
                                        padding: "4px 12px",
                                        border: "1px solid #ddd",
                                        background: "#fafafa",
                                        cursor: "pointer",
                                        borderRadius: "4px",
                                        fontSize: "14px"
                                    }}
                                    title="굵게 (선택 영역)"
                                >
                                    B
                                </button>

                                <div style={{ width: "1px", height: "20px", background: "#e0e0e0", margin: "0 4px" }} />

                                {memoColors.map((c) => (
                                    <button
                                        key={c.value}
                                        type="button"
                                        onMouseDown={preventFocusSteal}
                                        onClick={applyColor(c.value)}
                                        style={{
                                            width: "22px",
                                            height: "22px",
                                            borderRadius: "50%",
                                            background: c.value,
                                            border: c.value === "#000000" ? "1px solid #999" : "1px solid #ccc",
                                            cursor: "pointer",
                                            padding: 0
                                        }}
                                        title={c.name}
                                    />
                                ))}
                            </div>

                            {/* 리치 텍스트 에디터 */}
                            <div
                                ref={editorRef}
                                className="seatmemo-editor"
                                contentEditable
                                suppressContentEditableWarning
                                onInput={handleEditorInput}
                                style={{
                                    minHeight: "180px",
                                    padding: "8px 12px",
                                    border: "1px solid #cdd7e1",
                                    borderRadius: "6px",
                                    fontFamily: "Apple_SB",
                                    fontSize: "16px",
                                    lineHeight: "1.5",
                                    outline: "none",
                                    background: "#fff"
                                }}
                            />
                        </div>
                    </div>
                </>
            }



            {
                loading ?
                    <div style={{ width: "1200px", margin: "0 auto", marginTop: "30px" }}>
                        <LinearProgress color="neutral" />
                    </div>
                    :
                    location !== "job" ?
                        <div ref={ref} style={{ width: "2000px", margin: "0 auto", marginTop: "0px" }}>
                            {
                                (props.user && props.user.academy) &&

                                renderSeatSvg(location, props.user)
                            }
                        </div>
                        :
                        <div>
                            <JobAttendance user={props.user} />
                        </div>
            }




        </div>
    );

}

export default SeatList;